
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material"
import { iconos } from "../../data";
import { useLoteDistriXID } from "../../hooks";




export const DisenioLoteDistribuido = ({ children, titulo }) => {



    const { id } = useParams();
    const navigate = useNavigate();
    const { loteDistriXIDQuery } = useLoteDistriXID(`${id}`);
    const galpon = loteDistriXIDQuery?.data;


    const handleGoRoute = () => {
        navigate(-1)
    }


    return (

        <Grid sx={{minHeight:'100vh', width:'100%', background:'white', p:4, mt:0.5}}>
            <Grid item xs={ 12 } sx={{ display:'flex', alignItems:'center', mb:1.5 }}>
                <Typography variant='h4'>{ titulo }</Typography>

                <Box flex={1} />
                <Button variant="contained" color='secondary'
                    sx={{ color: '#fff', ':hover': { opacity: 0.5 }, py:1 }} onClick={ handleGoRoute }>
                    { iconos['back'] } 
                </Button>
            </Grid>

            {(loteDistriXIDQuery?.data) &&
            <Grid container>
                <Grid item xs={ 12 } sx={{display:'flex', alignItems:'center', justifyContent:'start'}}>
                    { React.cloneElement(iconos['setting'], {style:{ color:'#8B8B8B'} })}
                    <Typography variant='h5' ml={0.5} sx={{color:'#8B8B8B'}}>
                        {`Lote ${galpon.lote.lote} - ${galpon.galpon.nombre} - ${galpon.genero}`}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Box sx={{ mb:3, mt:1, height:"1.3px", background:"#8B8B8B", width:"100%" }} />
                </Grid>
            </Grid>
            }

            <Grid item xs={12} sx={{height:'82%'}}>
                { children }
            </Grid>
        </Grid>
    )

    
}
